import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import DebitoAutomatico from "../../components/Cotizacion/DebitoAutomatico";
import { FetchDatosDebitoAutomatico, FetchObtenerConductos } from "../../redux/actions/aCotizacion";

class ContainerDebitoAutomatico extends Component {

  componentDidMount() {  

    let ramo=this.props.dataFacturacion.datosFacturacion.carDescripcionRamo?this.props.dataFacturacion.datosFacturacion.carDescripcionRamo:'';
    if(this.props.dataFacturacion && this.props.dataFacturacion.datosFacturacion && this.props.dataFacturacion.datosFacturacion.carDescripcionSeguro && this.props.dataFacturacion.datosFacturacion.carDescripcionSeguro !=='' && this.props.dataFacturacion.datosFacturacion.carDescripcionSeguro !== null)
    {
        ramo=this.props.dataFacturacion.datosFacturacion.carDescripcionSeguro
    }

    this.props.listarDebitoAutomatico({
      "empresa": "AIGMETROPOLITANA",
      "ramo": ramo
    })

    this.props.listarConductos({
      "empresa": "AIGMETROPOLITANA",
      "plataforma": "WEB",
      "idCliente": this.props.dataFacturacion.datosFacturacion.datosPagador[0].id//this.props.datosCarrito.productosCarrito.carDatosPagadorFacturacion[0].id

    })
  }
  render() {

    return (
      <main className="cr-app bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
            <DebitoAutomatico />
          </div>
        </div>
      </main>
    );

  }
}

const mapStateToProps = state => ({
  dataUsuario: state.datosUsuarios.dataUsuario,
  datosCarrito: state.dataProductoCarrito,
  dataFacturacion : state.dataFacturacion
});

const mapDispatchToProps = dispatch => {
  return {
    listarDebitoAutomatico: datos => dispatch(FetchDatosDebitoAutomatico(datos)),
    listarConductos: datos => dispatch(FetchObtenerConductos(datos)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerDebitoAutomatico)
);
